<template>
  <div :id="id"/>
</template>

<script>
// deps for editor
import Editor from 'tui-editor/dist/tui-editor-Viewer'

export default {
  name: 'MarkdownViewer',
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default() {
        return 'markdown-viewer-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    }
  },
  data() {
    return {
      editor: null
    }
  },
  mounted() {
    this.initEditor()
  },
  methods: {
    initEditor() {
      this.editor = new Editor({
        el: document.getElementById(this.id),
        initialValue: this.value
      })
    }
  }
}
</script>
